module.exports = __webpack_public_path__ + "media/images/check-mark-a8ceab8f2f7bca586feb109c6e4b77a4.svg";